export enum tokenActionsTypes {
    GET_TOKEN_REQUEST = 'GET_TOKEN_REQUEST',
    GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS',
    GET_TOKEN_FAILURE = 'GET_TOKEN_FAILURE',
  }